import script from "./signUpModel.vue?vue&type=script&setup=true&lang=js"
export * from "./signUpModel.vue?vue&type=script&setup=true&lang=js"

import "./signUpModel.vue?vue&type=style&index=0&id=f6ea5546&lang=less&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6ea5546"]])

export default __exports__